import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {AdditionalField} from "../../../shared/interface/additionalField";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {takeUntil} from "rxjs/operators";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {HttpErrorResponse} from "@angular/common/http";
import {AdditionalFieldsService} from "../../../shared/services/additional-fields.service";

@Component({
  selector: 'app-additional-fields-details',
  templateUrl: './additional-fields-details.component.html',
  styleUrls: ['./additional-fields-details.component.scss']
})
export class AdditionalFieldsDetailsComponent implements OnInit, OnDestroy {

  uuid?: string = null;
  additionalFieldObject?: AdditionalField;
  additionalField: ReplaySubject<AdditionalField> = new ReplaySubject<AdditionalField>(1);
  modify = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private route: ActivatedRoute,
    private additionalFieldsService: AdditionalFieldsService,
    private snack: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.uuid = params.id;
        this.loadAdditionalField();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onTabChange(e: MatTabChangeEvent): void {
  }

  loadAdditionalField(): void {
    this.additionalFieldsService.getAdditionalField(this.uuid).subscribe((additionalField: AdditionalField) => {
      this.additionalField.next(additionalField);
      this.additionalFieldObject = additionalField;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych pola dodatkowego', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
